import { useEffect, useState } from "react";
import { fetchServedVersion, getLoadedVersion } from "./api";

/** Intervalo entre checagens com a aba aberta. Alem dele, checa ao montar,
 *  ao voltar para a aba e ao reconectar — que e quando o usuario de celular
 *  realmente volta ao app. */
export const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

/** `true` quando o servidor ja serve uma versao diferente da carregada nesta
 *  aba. Sticky: depois de detectada, so um reload limpa — voltar a ficar
 *  igual nao desfaz o fato de que o codigo desta aba esta velho. */
export function useUpdateAvailable(): boolean {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    const loaded = getLoadedVersion();
    if (!loaded) return; // dev/teste: sem build, nao ha o que comparar

    let cancelled = false;

    async function check() {
      const served = await fetchServedVersion();
      if (!cancelled && served && served !== loaded) setAvailable(true);
    }

    const onVisible = () => {
      if (document.visibilityState === "visible") void check();
    };
    // Chunk lazy que sumiu do servidor: deploy aconteceu e esta aba ainda
    // aponta para arquivos do build anterior.
    const onPreloadError = () => setAvailable(true);

    void check();
    const timer = window.setInterval(() => void check(), VERSION_CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("online", check);
    window.addEventListener("vite:preloadError", onPreloadError);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("online", check);
      window.removeEventListener("vite:preloadError", onPreloadError);
    };
  }, []);

  return available;
}
